import {nanoid} from "nanoid"
import Objdict from "objdict"

import World from "@fae/source/models/World.js"
import Step from "@fae/source/models/Step.js"
import Geometry from "@fae/source/utility/Geometry.js"
import GenerateEnvironmentArt from "@fae/source/data/games/ember/utility/GenerateEnvironmentArt.js"

import kits from "../envkits.js"

import genencounters from "@fae/source/data/games/ember/chapters/protoencounters/encounters.json"
import genunits from "@fae/source/data/games/ember/chapters/protoencounters/units.json"
import genspots from "@fae/source/data/games/ember/chapters/protoencounters/spots.json"

const ENCOUNTERS = genencounters.map((encounter) => {
    encounter = World.processEncounterPolygon(encounter)

    // Mark any and all spots that were defined with the
    // encounter, so they can be moved with them.
    encounter.spots = []
    Object.values(genspots).forEach((spot) => {
        if(Geometry.isInBounds(encounter, spot.position)) {
            encounter.spots.push(spot)
        }
    })
    encounter.units = []
    Object.values(genunits).forEach((unit) => {
        if(Geometry.isInBounds(encounter, unit.position)) {
            encounter.units.push(unit)
        }
    })

    encounter = translateEncounter(encounter, {
        "x": -1 * encounter.x1,
        "y": -1 * encounter.y1,
    })

    return encounter
})

const ENCOUNTER_TEMPLATES = {
    "first-combat": [
        {"unitKeys": ["ember/wisp-red", "ember/wisp-red", "ember/wisp-blue", "ember/wisp-green", "ember/wisp-green"]},
    ],
    "standard-combat": [
        {"unitKeys": ["ember/stag-blue", "ember/wolf-red", "ember/wolf-green", "ember/wolf-red", "ember/wolf-green"]},
        {"unitKeys": ["ember/bear-red", "ember/wolf-green", "ember/wolf-blue", "ember/wolf-green", "ember/wolf-blue"]},
        {"unitKeys": ["ember/stag-blue", "ember/crow-red", "ember/crow-green", "ember/crow-red", "ember/crow-green"]},
        {"unitKeys": ["ember/bear-red", "ember/crow-green", "ember/crow-blue", "ember/crow-green", "ember/crow-blue"]},

        // {"unitKeys": ["ember/wisp-red", "ember/wisp-red", "ember/wisp-blue", "ember/wisp-green", "ember/wisp-green"]},
        {"unitKeys": ["ember/leshy-green", "ember/leshy-green", "ember/woodsman-green", "ember/woodsman-green"]},
        {"unitKeys": ["ember/mothman-blue", "ember/mothman-blue", "ember/mothman-blue", "ember/mothman-blue"]},

        {"unitKeys": ["ember/kelpie-green", "ember/kelpie-blue", "ember/kelpie-green", "ember/kelpie-blue"]},
        {"unitKeys": ["ember/fish-red", "ember/fish-blue", "ember/fish-red", "ember/fish-blue"]},
        {"unitKeys": ["ember/bull-red", "ember/hare-red", "ember/bull-red", "ember/hare-red"]},
        {"unitKeys": ["ember/bones-blue", "ember/bones-blue", "ember/bones-red", "ember/bones-red", "ember/bones-green"]},
    ],
    "elite-combat": [
        {"bossUnitKey": "ember/boglord-green", "unitKeys": ["ember/boglet-green", "ember/boglet-green", "ember/boglet-green", "ember/boglet-green"]},
        {"unitKeys": ["ember/banshee-blue", "ember/banshee-blue", "ember/banshee-blue", "ember/banshee-blue"]},
        {"bossUnitKey": "ember/shepherd-red", "unitKeys": ["ember/wolf-green", "ember/wolf-blue", "ember/wolf-green", "ember/wolf-blue"]},
        {"bossUnitKey": "ember/rusalka-blue", "unitKeys": ["ember/kelpie-green", "ember/fish-red", "ember/kelpie-green", "ember/fish-red"]},
        {"bossUnitKey": "ember/priestess-blue", "unitKeys": ["ember/bones-blue", "ember/bones-red", "ember/bones-red", "ember/bones-green", "ember/bones-green"]},
        {"bossUnitKey": "ember/jester-blue", "unitKeys": ["ember/wisp-red", "ember/wisp-green", "ember/wisp-red", "ember/wisp-green"]},
        {"bossUnitKey": "ember/blazing-red", "unitKeys": ["ember/ashwraith-red", "ember/ashwraith-red", "ember/ashwraith-red", "ember/ashwraith-red"]},
        {"bossUnitKey": "ember/kikimora-green", "unitKeys": ["ember/crow-red", "ember/crow-blue", "ember/crow-red", "ember/crow-blue"]},
        {"bossUnitKey": "ember/pirate-red", "unitKeys": ["ember/pirate-blue", "ember/pirate-blue", "ember/pirate-blue", "ember/pirate-blue"]},
    ],
    "final-combat": [
        {"bossUnitKey": "ember/lordandlady-green", "unitKeys": ["ember/knight-green", "ember/bones-red", "ember/bones-red", "ember/bones-red"]},
    ],
    "treasure": [
        {"unitCount": 1, "spotKey": "center", "unitKeys": ["ember/torch/1", "ember/torch/2", "ember/torch/3"]},
    ],
    "campfire": [
        {"unitCount": 1, "spotKey": "center", "unitKeys": ["ember/campfire"]},
    ],
    "random": [
    ],
}


// const ENCOUNTER_SPECS = [
//     {
//         "encounterKey": "1",
//         // "unitJobKeys": ["monster/slime/fire", "monster/slime/water", "monster/slime/fire", "monster/slime/earth"],
//         "x": 0,
//         "y": 0,
//     },
//     {
//         "encounterKey": "2",
//         // "unitJobKeys": ["monster/skeleton", "monster/skeleton"],
//         "x": 10,
//         "y": -1,
//     },
//     {
//         "encounterKey": "3",
//         // "unitJobKeys": ["monster/slime/fire", "monster/slime/fire", "monster/slime/earth"],
//         // "goodUnitKeys": ["frog"],
//         "x": 20,
//         "y": 0,
//     },
//     {
//         "encounterKey": "4",
//         // "unitJobKeys": ["monster/skeleton", "monster/skeleton", "monster/goblin", "monster/goblin"],
//         "x": 30,
//         "y": +1,
//     },
//     {
//         "encounterKey": "5",
//         // "unitJobKeys": ["monster/slime/water", "monster/slime/water", "monster/slime/queen"],
//         "x": 40,
//         "y": 0,
//     },
// ]

export default function GenerateEncounter(encounterKey) {
    return function(stage) {
        console.log("generating...", stage.overworld?.player.encounter)
        let returnedSpots = []
        let returnedEncounters = []
        let returnedUnits = []

        // Filter for all non-numbered encounters.
        // These are our custom room templates!!
        // encounters = Object.values(stage.encounters).filter((encounter) => {
        //     // return Number.isNaN(Number.parseFloat(encounter.key))
        //     return true
        // })

        let returnedEncounter = undefined

        if(stage?.overworld?.player?.encounter?.encounterKey != undefined) {
            returnedEncounter = ENCOUNTERS.find((encounter) => encounter.key == stage.overworld.player.encounter.encounterKey)
        }

        if(returnedEncounter == undefined) {
            // Randomize the order of the rooms.
            returnedEncounter = stage.random.shuffle(ENCOUNTERS).pop()
        }

        let currentPosition = {"x": 0, "y": 7}
        returnedEncounter = translateEncounter(returnedEncounter, {
            "x": currentPosition.x + (encounterKey * 16 || 0),
            "y": currentPosition.y + (0 || 0)
        })
        returnedEncounter.key = encounterKey
        returnedEncounters.push(returnedEncounter)
        returnedSpots = returnedSpots.concat(returnedEncounter.spots)
        returnedUnits = returnedUnits.concat(returnedEncounter.units)

        let encounterTemplate = undefined
        if(stage?.overworld?.player?.encounter?.encounterTemplate != undefined) {
            encounterTemplate = stage.overworld.player.encounter.encounterTemplate
        }
        if(encounterTemplate == undefined) {
            encounterTemplate = stage.random.element(ENCOUNTER_TEMPLATES[stage?.overworld?.player?.encounter?.type ?? "first-combat"] || [undefined])
        }
        if(encounterTemplate != undefined) {
            let badSpots = returnedEncounter.spots.filter((spot) => spot.tag == (encounterTemplate?.spotKey || "badspawn"))
            let goodSpots = returnedEncounter.spots.filter((spot) => spot.tag == "goodspawn")
            badSpots = stage.random.shuffle(badSpots)
            goodSpots = stage.random.shuffle(goodSpots)

            let unitKeys = []
            if(encounterTemplate.bossUnitKey != undefined) {
                unitKeys.push(encounterTemplate.bossUnitKey)
            }
            if(encounterTemplate.unitKeys != undefined) {
                unitKeys = unitKeys.concat(stage.random.shuffle(encounterTemplate.unitKeys))
            }

            for(let i = 0; i < (encounterTemplate.unitCount ?? 3); i += 1) {
                const spot = badSpots.shift()
                badSpots.push(spot)
                if(spot == undefined) {
                    continue
                }

                let unitJobKey = unitKeys.shift()
                unitKeys.push(unitJobKey)
                if(unitJobKey == undefined) {
                    continue
                }

                returnedUnits.push({
                    "key": "spawned" + nanoid(),
                    "jobKey": unitJobKey,
                    "position": {
                        "x": spot.position.x,
                        "y": spot.position.y,
                        "z": spot.position.z
                    },
                })
            }
        }

        // if(spec.goodUnitKeys != undefined) {
        //     spec.goodUnitKeys.forEach((unitKey) => {
        //         const spot = goodSpots.pop()
        //         const unit = stage.player.units[unitKey]
        //         if(spot == undefined) return
        //         if(unit == undefined) return
        //         returnedUnits.push({
        //             ...unit,
        //             "position": {
        //                 "x": spot.position.x,
        //                 "y": spot.position.y,
        //                 "z": spot.position.z
        //             }
        //         })
        //     })
        // }

        currentPosition.x += returnedEncounter.width

        const returnedImages = GenerateEnvironmentArt({
            "encounters": returnedEncounters,
            "kits": kits["woods"]
        })
        // console.log(returnedEncounters)

        return [
            Step.deltastage({
                // "encounters": Objdict.convert(returnedEncounters),
                // "spots": Objdict.convert(returnedSpots),
                "encounters": Objdict.merge(stage.encounters, Objdict.convert(returnedEncounters)),
                "spots": Objdict.merge(stage.spots, Objdict.convert(returnedSpots)),
            }),
            Step.deltastage({
                "units": Objdict.convert(returnedUnits), // THIS IS A MERGE!!!
            }),
            Step.deltastage({
                // "images": (stage.images || []).concat(returnedImages),
                "images": returnedImages,
            })
        ]
    }
}

function translateEncounter(encounter, {x, y}) {
    return {
        ...encounter,

        "center": {
            "x": encounter.center.x + x,
            "y": encounter.center.x + y,
        },
        "units": !!encounter.units && encounter.units.map((unit) => {
            return {
                ...unit,
                "position": {
                    "x": unit.position.x + x,
                    "y": unit.position.y + y,
                    "z": unit.position.z,
                }
            }
        }),
        "spots": !!encounter.spots && encounter.spots.map((spot) => {
            return {
                ...spot,
                "key": nanoid(),
                "position": {
                    "x": spot.position.x + x,
                    "y": spot.position.y + y,
                    "z": spot.position.z,
                }
            }
        }),
        "points": encounter.points.map((point) => {
            return {
                ...point,
                "x": point.x + x,
                "y": point.y + y
            }
        }),
        "x": encounter.x + x,
        "y": encounter.y + y,
        "x1": encounter.x1 + x,
        "y1": encounter.y1 + y,
        "x2": encounter.x2 + x,
        "y2": encounter.y2 + y,
    }
}
